import React, { useEffect, useState, useRef, memo } from "react";
import { WebService } from "../../Services/WebService";
import "../Company/Company.css";
import { ActionPermission, PageInfo } from "../PageInfo";
import SnackbarComponent from "../../Services/SnackbarComponent";
import "../Company/Company.css";
import ActionButton from "../../Services/ActionButton";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import AddEditShiftTiming from "./AddEditShiftTiming";
import DeleteConfirmAlert from "../../Services/AlertComponent";
import { DateTime } from "luxon";
import AssignShit from "./AssignShit";
import ShiftCard from "./ShiftCard";
import AppbarComponent from "../../Services/AppbarComponent";
import TopbarComponent from "../../Services/TopbarComponent";
import { WSSuccessAlert } from "../../Services/WSAlert";

const ShiftsTiming = () => {
  const refSnackbar = useRef();
  PageInfo({ pageTitle: "Shift Timing" });
  const [records, setRecords] = useState([]);
  const dispatch = useDispatch();
  const { state } = useLocation();
  const deleteConfirmAlertRef = useRef();
  const AssignShiftRef = useRef();
  const [filters, setFilters] = useState({
    FromTime: "",
    ToTime: "",
    OfficeLocationId: "",
  });
  
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);

  const fetchdata = async () => {
    const data = await WebService({
      endPoint: `ShiftTiming/fetch`,
      method: "post",
      body: {
        page,
        limit,
        filters,
      },
      dispatch,
    });
    setRecords(data.data);
    setTotal(data.total);
  };
  const permissionList = useSelector((s) => s.auth.PermissionList ?? []);
  const [permission, setPermission] = useState({});
  useEffect(() => {
    setPermission({
      ManageAdd: ActionPermission("Shift Timing Add"),
      ManageEdit: ActionPermission("Shift Timing Edit"),
      ManageDelete: ActionPermission("Shift Timing View"),
      ManageView: ActionPermission("Shift Timing Delete"),
      // ManageDelete: ActionPermission("Roles - Delete"),
    });
  }, [permissionList]);

  // const renderAfterCalled = useRef(false);
  const addEditModalRef = useRef();
  const fnEdit = async (id) => await addEditModalRef.current.openModal(id || 0);
  const fnAssignShift = async (id) => await AssignShiftRef.current.openModal(id || 0);


  useEffect(() => {
    fetchdata();
  }, [page, limit]);

  const onDelete = async (id) => {
    await WebService({
      endPoint: `CommonUtility/ShiftTiming?WorkShiftId=${id}`,
      method: "DELETE",
      dispatch,
    });
    refSnackbar.current.setOpenSnackBar();
     WSSuccessAlert(
          "Success",
          `Shift deleted successfully.`
        );
    await fetchdata();
  };
  const columns = [
    {
      Text:'Shift Name',
      Value:'ShiftName',
    },
    {
      Text: "ShiftTimings",
      Value: "FromTime",
      render:(dr)=>{
        return (
          <span className="d-flex flex-row flex-nowrap">
          {DateTime.fromFormat(dr.FromTime, "HH:mm:ss").toFormat("HH:mm")}
          &nbsp;-&nbsp;
          {DateTime.fromFormat(dr.ToTime, "HH:mm:ss").toFormat("HH:mm")}
        </span>
        
        )
      }
    },
  

    
    {
      Text: "Office Location ",
      Value: "OfficeLocationId",
      render: (dr) => {
        return (
          <>{dr.Location}</>
        )
      }
    },
    {
      Text: "OverTime Allowed",
      Value: "AllowOverTime",
      render: (dr)=> {
        return (
          <>{dr.AllowOverTime === 1 ? 'yes': 'no' }</>
        )
      }
    },
    {
      Text: "AutoCheckout",
      Value: "AutoCheckout",
      render: (dr)=> {
        return (
          <>{dr.AutoCheckout === 1 ? 'yes': 'no' }</>
        )
      }
    },
    {
      Text: "ShiftApplicableStartDate",
      Value: "ShiftApplicableStartDate",
      render: (dr) => {
        return (
          <>{DateTime.fromISO(dr.ShiftApplicableStartDate).toFormat("dd/MM/yyyy") } - {DateTime.fromISO(dr.ShiftApplicableEndDate).toFormat("dd/MM/yyyy") } </>
        )
      }
    },
    {
      Text: "Action",
      key: "PerformanceId",
      cssClass: "text-center td-width-100",
      isVisiable: permission.ManageEdit || permission.ManageDelete,
      NotUseInExport: true,
      render: (dr) => (
        <div className="d-flex">
          {permission.ManageEdit && (
            <ActionButton
              onClick={() => fnEdit(dr.WorkShiftId)}
              IconName="Edit"
              id="btnPerformanceEdit"
            />
          )}

          {permission.ManageDelete && (
            <ActionButton
              onClick={(e) =>
                deleteConfirmAlertRef.current.confirmAlert(
                  "Delete", //Confirm button text
                  "Are You Sure", // Text if Alert
                  "Do you want to delete " + MasterPageName, // Message of Alert
                  dr.WorkShiftId // Endpoint to hit for delete
                )
              }
              IconName="Delete"
              id="btnerformanceEditDelete"
            />
          )}

          <ActionButton
              onClick={()=> fnAssignShift(dr.WorkShiftId)}
              IconName="Assign"
              id="btnAssignShift"
            />
        </div>
      ),
    },
  ];

  const [bData, setBData] = React.useState([
    {
      title: "Shifts",
      hrefLink: "#",
    },
    {
      title: "Shift Timings",
      hrefLink: "#",
    },
  ]);
  const MasterPageName = "Shift Timings";
  const confirmMessage = MasterPageName + " Deleted successfully";

  return (
    <>
      {/* <StaticListComponent
        columns={columns}
        records={records}
        bData={bData}
        MasterPageName={MasterPageName}
        noRecordCss="p-0"
        BackBtnReturnPath={
          state?.SourcePageName === StandardConst.ReturnPagePaths.ActionCenter
            ? StandardConst.ReturnPagePaths.ActionCenter
            : ""
        } // give sorce page path in this parameter when you use this component the back button will back you to the source page
        noRecordFound={
          <NoRecordTemplate
            headerValue={StandardConst.headerValueNoResults}
            subHeaderValue={StandardConst.subHeaderValueStandard}
            imageUrl={StandardConst.imageNoRecordsFound}
            actionButton={
              <>
                {permission.ManageAdd && (
                  <Button variant="outline-primary" onClick={() => fnEdit(0)}>
                    Add {MasterPageName}
                  </Button>
                )}
              </>
            }
          />
        }
        onAddEvent={() => fnEdit()}
        IsAddButtonVisible={permission?.ManageAdd}
        isSearchRequired={true}
        allowSerialNo={true}
      ></StaticListComponent> */}
      <TopbarComponent bData={bData} HeadingText={MasterPageName} />
      <AppbarComponent
        title={MasterPageName}
        isSearchRequired={false}
        isAddButtonRequired={true}
        Exception={true}
        onAddEvent={() => fnEdit(0)}
        buttonClass={'align_right'}
      />

      
      <div className="container mt-2">
        <div className="row">
          {records.map((item, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-4 mb-4 d-flex">
              <ShiftCard
                shift={item}
                onEdit={fnEdit}
                onDelete={(id) =>
                  deleteConfirmAlertRef.current.confirmAlert(
                    "Delete",
                    "Are You Sure",
                    "Do you want to delete",
                    id
                  )
                }
                onAssign={fnAssignShift}
              />
            </div>
          ))}
        </div>
      </div>

      <AddEditShiftTiming
        callBackEvent={() => fetchdata()}
        ref={addEditModalRef}
      />
      <DeleteConfirmAlert
        ref={deleteConfirmAlertRef}
        confirmEvent={(v) => onDelete(v)}
      />
      <AssignShit ref={AssignShiftRef} />
      <SnackbarComponent ref={refSnackbar} confirmMessage={confirmMessage} />
    </>
  );
};

export default memo(ShiftsTiming);
